import { Type, Transform } from 'class-transformer';
import {
  IsInt,
  IsNumber,
  IsIn,
  IsArray,
  IsString,
  IsDateString,
  IsUUID,
  IsNotEmpty,
  ValidateNested,
  IsOptional,
  IsBoolean,
} from 'class-validator';

export type Phone = string;

export class CandidateItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsUUID()
  @IsNotEmpty()
  event_id: string;

  @IsString()
  @IsNotEmpty()
  first_name: string;

  @IsString()
  @IsNotEmpty()
  last_name: string;

  @IsString()
  @IsOptional()
  middle_name?: string;

  @IsString()
  @IsNotEmpty()
  phone: string;

  @Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] })
  @IsString()
  @IsOptional()
  email?: string;
}

export class CandidateSimilarResponse {
  @ValidateNested({ each: true })
  @Type(() => CandidateItem)
  @IsArray()
  @IsNotEmpty()
  candidates: CandidateItem[];
}

export class CandidateCreateEventResponse {
  @IsUUID()
  @IsNotEmpty()
  event_id: string;
}

export class CandidateEventTypeItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  custom_type: string;
}

export class CandidateCreateEventTypeOptionsResponse {
  @ValidateNested({ each: true })
  @Type(() => CandidateEventTypeItem)
  @IsArray()
  @IsNotEmpty()
  event_types: CandidateEventTypeItem[];
}

export type CryptoProPluginOpenType = string;

export class CompanyItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsOptional()
  tsp_url?: string;

  @IsIn(['capi', 'cades'])
  @IsString()
  @IsOptional()
  crypto_pro_plugin_open_type?: 'capi' | 'cades';

  @IsIn(['api', 'browser_plugin'])
  @IsString()
  @IsOptional()
  hash_source?: 'api' | 'browser_plugin';
}

export class CandidateCreateEventTypeCompaniesResponse {
  @ValidateNested({ each: true })
  @Type(() => CompanyItem)
  @IsArray()
  @IsNotEmpty()
  companies: CompanyItem[];
}

export class CandidateResponse {
  @ValidateNested()
  @Type(() => CandidateItem)
  @IsNotEmpty()
  candidate: CandidateItem;
}

export type AccessToken = string;

export class CandidateLoginResponse {
  @IsString()
  @IsNotEmpty()
  access_token: string;
}
